import { LogIn, LogOut } from 'lucide-react';
import { describeActivity } from '../utils/activityDescription';

const EVENT_STYLE = {
    login:  { icon: LogIn,  chip: 'bg-emerald-50 text-emerald-700', label: 'Sign in' },
    logout: { icon: LogOut, chip: 'bg-ink-100 text-ink-700',       label: 'Sign out' },
};

/**
 * Sign-in / sign-out history for one actor.
 */
export default function AuthSessionTable({ items, emptyMessage = 'No sign-in activity recorded yet. New sign-ins and sign-outs will appear here.' }) {
    return (
        <div className="ag-card p-0 overflow-x-auto">
            <table className="w-full text-sm">
                <thead className="bg-ink-100">
                    <tr>
                        <th className="px-3 py-3 text-left text-[10px] font-bold uppercase tracking-wider text-ink-500 whitespace-nowrap">When</th>
                        <th className="px-3 py-3 text-left text-[10px] font-bold uppercase tracking-wider text-ink-500">Event</th>
                        <th className="px-3 py-3 text-left text-[10px] font-bold uppercase tracking-wider text-ink-500">Details</th>
                        <th className="px-3 py-3 text-left text-[10px] font-bold uppercase tracking-wider text-ink-500">IP</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(l => {
                        const style = EVENT_STYLE[l.action] || EVENT_STYLE.login;
                        const Icon = style.icon;
                        const { summary } = describeActivity(l);

                        return (
                            <tr key={l._id} className="border-b border-ink-100 hover:bg-brand-teal-50/30 transition">
                                <td className="px-3 py-2 text-xs text-ink-500 whitespace-nowrap">{new Date(l.at).toLocaleString()}</td>
                                <td className="px-3 py-2">
                                    <span className={`inline-flex items-center gap-1.5 ag-chip ${style.chip}`}>
                                        <Icon className="h-3.5 w-3.5" />
                                        {style.label}
                                    </span>
                                </td>
                                <td className="px-3 py-2 text-sm text-ink-800">{summary}</td>
                                <td className="px-3 py-2 font-mono text-[10px] text-ink-500">{l.ip || '—'}</td>
                            </tr>
                        );
                    })}
                    {items.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center text-ink-500 py-10 text-sm">{emptyMessage}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
